'use es6';

import { createSelector } from 'reselect';

const getLeadSyncingEntities = state => state.leadSyncingEntities;

export const getSelectedLeadSyncingEntities = createSelector(getLeadSyncingEntities, leadSyncingEntities => leadSyncingEntities.get('selected'));